import { Formik } from "formik";
import { Button, buttonVariants } from "@/components/ui/button";
import { DialogClose } from "@/components/ui/dialog";
import { CustomInput, CustomSelect } from "@/components";
import { Class } from "@/types/class.types";
import * as Yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateClass } from "@/api/common";
import { showSuccessToast } from "@/lib/toast";
import { SelectOption } from "@/components/CustomSelect";

type EditArmProps = {
  closeModal: () => void;
  arm: Class;
  levels: SelectOption[]
};

const EditArm = ({ closeModal, arm, levels }: EditArmProps) => {
  const queryClient = useQueryClient();

  const initialValues = {
    classID: arm?.id ?? "",
    name: arm?.class ?? "",
    level: arm?.level_id ?? "",
  };
  const validationSchema = Yup.object().shape({
    name: Yup.string().required("This field is required"),
    level: Yup.string().required("This field is required"),
  });

  const { mutate, isLoading } = useMutation(updateClass, {
    onSuccess: () => {
      showSuccessToast("Class updated successfully");
      queryClient.invalidateQueries({ queryKey: ["classes"] });
      closeModal();
    },
  });

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values) => mutate(values)}
    >
      {({ values, handleChange, handleSubmit, setFieldValue }) => (
        <form
          className="flex flex-col justify-between flex-grow h-full gap-6 pb-8"
          onSubmit={handleSubmit}
        >
          <div className="py-4 space-y-5">
            <CustomInput
              label="Class name"
              id="name"
              name="name"
              placeholder="Enter Class name"
              value={values.name}
              onChange={handleChange}
            />
            <CustomSelect
              options={levels}
              label="Level"
              id="level"
              name="level"
              placeholder="Select level"
              value={values.level}
              onChange={(val) => setFieldValue("level", val)}
            />
          </div>
          <div className="flex items-center justify-end w-full gap-2">
            <DialogClose
              type="button"
              className={buttonVariants({
                variant: "outline",
              })}
            >
              Cancel
            </DialogClose>
            <Button disabled={isLoading} className="min-w-[100px]">
              Submit
            </Button>
          </div>
        </form>
      )}
    </Formik>
  );
};

export default EditArm;
